module.exports = {
          srcSet: __webpack_public_path__ + "d18d91fb31d6355cfe33a5d37e1cef22-328.png"+" 328w",
          images:[ {path: __webpack_public_path__ + "d18d91fb31d6355cfe33a5d37e1cef22-328.png",width: 328,height: 328}],
          src: __webpack_public_path__ + "d18d91fb31d6355cfe33a5d37e1cef22-328.png",
          toString:function(){return __webpack_public_path__ + "d18d91fb31d6355cfe33a5d37e1cef22-328.png"},
          
          width: 328,
          height: 328
        }